<template>
  <el-dialog
    title="省/市/区选择器"
    :visible.sync="show"
    :close-on-click-modal="false"
  >
    <el-select
      ref="provinceSelectRef"
      v-model="emit_data.province_id"
      placeholder="省份"
      filterable
      @change="selectProvince"
    >
      <el-option
        v-for="item in province"
        :key="item.id"
        :value="item.id"
        :label="item.name"
      >
      </el-option>
    </el-select>

    <el-select
      ref="citySelectRef"
      v-model="emit_data.city_id"
      placeholder="城市"
      filterable
      @change="selectCity"
    >
      <el-option
        v-for="item in city"
        :key="item.id"
        :value="item.id"
        :label="item.name"
      >
      </el-option>
    </el-select>

    <el-select
      ref="areaSelectRef"
      v-model="emit_data.area_id"
      multiple
      placeholder="区县"
      filterable
      @change="selectArea"
    >
      <el-option
        v-for="item in area"
        :key="item.id"
        :value="item.id"
        :label="item.name"
      >
      </el-option>
    </el-select>
    <div slot="footer">
      <el-button type="primary" @click="comfirm">确定</el-button>
      <el-button type="infor" @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      province: [], // 省
      city: [],
      area: [],

      emit_data: {
        province_id: "",
        city_id: "",
        area_id: [],

        province_text: "",
        city_text: "",
        area_text: [],
      },
    };
  },

  methods: {
    call() {
      this.show = true;
      this.loadProvince();
    },

    // 加载省份
    loadProvince() {
      // 有的时候就不加载了
      // if (this.province.length > 0) return;
      this.fetch("getProvince").then(rs => {
        this.province = rs.list;
      });
    },

    // 选择省份
    selectProvince(value) {
      this.getLabel("provinceSelectRef", v => {
        this.emit_data.province_text = v.label;
      });
      this.loadCity();
      this.emit_data.city_id = "";
      this.emit_data.city_text = "";
      this.emit_data.area_id = [];
      this.emit_data.area_text = [];
    },

    // 加载城市
    loadCity() {
      let province = this.emit_data.province_id;
      // if (typeof this.city[province] != 'undefined') return;
      this.fetch("getCity", { province }).then(rs => {
        this.city = rs.list;
      });
    },

    // 选择城市
    selectCity() {
      this.getLabel("citySelectRef", v => {
        this.emit_data.city_text = v.label;
      });
      this.loadArea();
      this.emit_data.area_id = [];
      this.emit_data.area_text = [];
    },

    // 加载区县
    loadArea() {
      let city = this.emit_data.city_id;
      this.fetch("getDistrict", { city }).then(rs => {
        this.area = rs.list;
      });
    },

    // 选择县区
    selectArea() {
      this.getLabel("areaSelectRef", v => {
        // this.emit_data.area_text = v;
        this.emit_data.area_text = [];
        v.forEach(vem => {
          this.emit_data.area_text.push(vem.label);
        });
      });
    },

    // 确定
    comfirm() {
      let data = {
        value: [],
        label: [],
      };
      if (!this.emit_data.province_id || !this.emit_data.city_id) {
        return this.$message.e("请至少选择到城市");
      }
      // if (this.emit_data.province_id) {
      data.value.push(this.emit_data.province_id);
      data.label.push(this.emit_data.province_text);
      // }

      // if (this.emit_data.city_id) {
      data.value.push(this.emit_data.city_id);
      data.label.push(this.emit_data.city_text);
      // }

      let cmit = []; // [{value:[], label:[]}]

      if (this.emit_data.area_id.length > 0) {
        // data.value.push(this.emit_data.area_id);
        // data.label.push(this.emit_data.area_text);
        this.emit_data.area_id.forEach((area_id, index) => {
          cmit.push({
            value: data.value.concat(area_id).join("/"),
            label: data.label.concat(this.emit_data.area_text[index]).join("/"),
          });
        });
      } else {
        cmit.push({
          value: data.value.join("/"),
          label: data.label.join("/"),
        });
      }
      this.$emit("submit", cmit);
      this.close();
    },

    // 关闭
    close() {
      this.show = false;
      this.clear();
    },

    clear() {
      this.emit_data.province_id = "";
      this.emit_data.city_id = "";
      this.emit_data.area_id = [];
      this.emit_data.province_text = "";
      this.emit_data.city_text = "";
      this.emit_data.area_text = [];
      this.city = [];
      this.area = [];
    },

    fetch(url, param) {
      param = param || {};
      return new Promise((resolve, reject) => {
        this.$http.post(`/erp/Common/${url}`, param).then(rs => {
          if (rs.data.code != 200) {
            this.$message.e(rs.data.msg);
            reject();
            return;
          }
          resolve(rs.data.data);
        });
      });
    },

    getLabel(ref, fn) {
      this.$nextTick(_ => {
        fn(this.$refs[ref].selected);
        // console.log('aaa', this.$refs[ref]);
      });

      // return this.$refs[ref].selected.label;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SelectRegionDialog.vue